export const _setCbpAuthPdfPrint = (state, action) => {
  state.cbpAuthPdfPrint = action.payload;
};
